export default __webpack_public_path__ + "static/media/logo.d97664e3.svg";